import type { IChartSelection } from "~/feature/chart/types";

export const buildChartRequest = ({ selections, range }: IChartSelection) => ({
  params: { markets: [...selections].sort().join(","), range },
  options: { skip: !selections.length },
});
